module.exports = __webpack_public_path__ + "static/media/2008_Population_totalRate.2ac643c6.png";